"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SeparatorTextLine;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dataAids = _interopRequireDefault(require("../constants/dataAids"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var separatorTextPseudoStyles = {
  content: "\"\"",
  position: 'absolute',
  display: 'block',
  height: '1px',
  top: '.6em',
  width: '100vw',
  background: 'currentColor',
  opacity: '0.5'
};

function SeparatorTextLine(_ref) {
  var text = _ref.text,
      separatorStyles = _ref.separatorStyles;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Block = _UX2$Element.Block,
      Text = _UX2$Element.Text;
  var styles = {
    separatorLine: _objectSpread({
      width: '100%',
      textAlign: 'center',
      overflow: 'hidden'
    }, separatorStyles),
    separatorTextWrapper: {
      'position': 'relative',
      'display': 'inline-block',
      'fontColor': 'lowContrast',
      ':before': _objectSpread({
        right: '100%',
        marginRight: 'small'
      }, separatorTextPseudoStyles),
      ':after': _objectSpread({
        left: '100%',
        marginLeft: 'small'
      }, separatorTextPseudoStyles)
    },
    separatorText: {
      textTransform: 'uppercase'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.separatorLine
  }, /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.separatorTextWrapper
  }, /*#__PURE__*/_react["default"].createElement(Text, {
    "data-aid": _dataAids["default"].SEPARATOR_TEXT_LINE_TEXT,
    tag: "span",
    style: styles.separatorText,
    featured: true
  }, text)));
}

SeparatorTextLine.propTypes = {
  text: _propTypes["default"].string,
  separatorStyles: _propTypes["default"].object
};